const ParameterType = {
  Group: 'Group',
  String: 'String',
  Radio: 'Radio',
  Json: 'json',
};
export { ParameterType };
